import React, { PureComponent } from "react";
import { Spinner as RSpinner } from "reactstrap";

/** @class
 * This class is used as react-strap's Spinner Compontent
 */

class Spinner extends PureComponent {
  render() {
    return <RSpinner {...this.props} />;
  }
}

export default Spinner;
